import React from 'react'
import { IIconProps as IProps } from './IIconProps'

const IconHeading = (props: IProps) => (
  <svg
    style={{
      width: `${props.size}px`,
      height: `${props.size}px`,
    }}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g transform="translate(1.818 3.273)">
      <path
        fill={props.color}
        d="M8.54049 0C8.64091 0 8.72231 0.0814028 8.72231 0.181818V9.27273C8.72231 9.37314 8.64091 9.45454 8.54049 9.45454H6.70317C6.60276 9.45454 6.52136 9.37314 6.52136 9.27273V5.76C6.52136 5.65958 6.43995 5.57818 6.33954 5.57818H2.38278C2.28236 5.57818 2.20096 5.65958 2.20096 5.76V9.27273C2.20096 9.37314 2.11955 9.45454 2.01914 9.45454H0.181818C0.0814029 9.45454 0 9.37314 0 9.27273V0.181818C0 0.0814029 0.0814028 0 0.181818 0H2.01914C2.11955 0 2.20096 0.0814028 2.20096 0.181818V3.54597C2.20096 3.64639 2.28236 3.72779 2.38278 3.72779H6.33954C6.43995 3.72779 6.52136 3.64639 6.52136 3.54597V0.181818C6.52136 0.0814026 6.60276 0 6.70317 0H8.54049Z"
      />
      <path
        fill={props.color}
        d="M12.1818 3.78182C12.2822 3.78182 12.3636 3.86322 12.3636 3.96364V9.27273C12.3636 9.37314 12.2822 9.45454 12.1818 9.45454H11.2249C11.1245 9.45454 11.0431 9.37314 11.0431 9.27273V5.01714C11.0431 4.91673 10.9617 4.83532 10.8612 4.83532H10.0836C9.98323 4.83532 9.90182 4.75392 9.90182 4.65351V3.96364C9.90182 3.86322 9.98323 3.78182 10.0836 3.78182H12.1818Z"
      />
    </g>
  </svg>
)

export default IconHeading
